import SiHaDocumentationModelBase from '../_generated/modelBases/si-ha-documentation-model-base';

export default class SiHaDocumentationModel extends SiHaDocumentationModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
